import { isServer } from 'lit'

/**
 * Whether the user has requested reduced motion via the
 * `prefers-reduced-motion: reduce` media query. Always `false` on the server,
 * where `window` is unavailable. Use it to skip JS-driven animations (CSS
 * `transition` declarations should also guard themselves with the same query).
 */
export function prefersReducedMotion(): boolean {
  return !isServer && window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
